import { formatDate, gridSize, gridSizeMdLg12, gridSizeMdLg4, newSolicitudesIngresoSchema, ROUTER_PATHS, useCheckPermissions, } from "@/shared";
import { CustomTextFieldNoForm, SampleDatePicker, SingleTableBoxScene, TabTextLabel } from "@/shared/components/ui";

import { MaterialTransferido, SaveSolicitudIngresoFormData, SolicitudesIngreso } from "@/shared/interfaces";

import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import { yupResolver } from "@hookform/resolvers/yup";
import { Divider, Grid, Paper, TextField, Typography } from "@mui/material";
import { useEffect } from "react";
import { Controller, useForm } from "react-hook-form";
import ModalProductoComponente from "./ModalProductoComponente";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import useTableColumnsSolicitudIngreso from "@/shared/hooks/useTableColumnsSolicitudIngreso";
import { useUpdateSolicitudesIngresos } from "@/shared/actions/erp";
import { PermissionsEnum } from "@/auth/interfaces";
import { useNavigate } from "react-router-dom";
import { useAuthStore } from "@/store/auth";

type EditSolicitudIngreso = {
  title: string;
  editData?: SolicitudesIngreso;
}

export default function EditSolicitudIngreso({ title, editData }: EditSolicitudIngreso) {
  useCheckPermissions(PermissionsEnum.api_change_solicitudingreso)
  ///console.log(editData)
  const navigate = useNavigate()
  //store
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const handldeCopiarLista = useCargarSeriesProductos(s => s.handleCopiarLista)
  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  //const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const { columnsSolicitudIngreso } = useTableColumnsSolicitudIngreso()
  //*form
  const form = useForm<SaveSolicitudIngresoFormData>({
    resolver: yupResolver(newSolicitudesIngresoSchema),
  })
  const { control,
    handleSubmit,
    reset,
    formState: { errors }
  } = form
  ///fetch
  const updateSolicitudIngreso = useUpdateSolicitudesIngresos({
    navigate,
    returnUrl: ROUTER_PATHS.inventario.solicitud_ingreso_compraNav
  })
  ///update
  const onUpdate = (data: SaveSolicitudIngresoFormData) => {
    
    const { user, ...resData } = data
    const result = {
      id: editData?.id_solicitudingreso!,
      data: {
        ...resData,
        productos: productos
      }
    }
    //console.log('json', result)
    updateSolicitudIngreso.mutate(result)
    /* const resp = {
      ...editData!,
      ...data,
      productos: productos,
      //user: editData?.user?.id

    }
    updateSolicitudIngreso.mutate({
      id:editData?.id_solicitudingreso!, 
      data:resp
    }) */
    /* console.log('resp', resp)
    if (editData) {
      updateSolicitudIngreso.mutate({
        id: editData.id_solicitudingreso!,
        data: resp
      })
    } */
  }

  ///*****
  useEffect(() => {
    if (editData) {
      reset({ ...editData,
         email_remitente: (editData as any).email_remitente || useAuthStore.getState().user?.email || '',
         email_receptor: (editData as any).email_receptor || editData.bodega_data?.email || '',
       } as any)
      if (editData.productos) {
        const aux = editData.productos.map((elementos: any) => ({
          ...elementos,
          codigo: elementos.codigo?.toString(),
          cantidad: elementos.cantidad !== undefined ? elementos.cantidad.toString() : '0'
        }))
        handldeCopiarLista(aux as any)
      }

    }
  }, [editData])
  return (
    <>
      <SingleTableBoxScene
        title={title}
        enableBackBtn={true}
        backPageUrl={ROUTER_PATHS.inventario.solicitud_ingreso_compraNav}
        enableCreateOrEditBtn={true}
        textCreateOrEditBtn="Guardar"
        fnCreateOrEdit={handleSubmit(onUpdate, (errors) => console.log(errors))}
      >
        <Grid container spacing={3}>
          <Grid item {...gridSize}>
            <Paper variant="outlined" sx={{ p: 2, width: '100%', mx: 'auto' }}>
              <Grid>
                <Typography variant="h6" sx={{ color: '#717a8ab0' }}>{'Información General'}</Typography>
              </Grid>
              <Divider sx={{ my: 2.5 }} />
              <Grid container spacing={3}>
                <SampleDatePicker
                  disabled={true}
                  label="Fecha creación"
                  control={control}
                  error={errors.fecha_creacion}
                  helperText={errors.fecha_creacion?.message}
                  name="fecha_creacion"
                  textFieldKey="fecha_creacion"
                  size={gridSizeMdLg4}
                  defaultValue={formatDate(new Date()) || ''}
                />
                <CustomTextFieldNoForm
                  label="bodaga"
                  value={editData?.bodega_data?.nombre}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <CustomTextFieldNoForm
                  label="Ubicacion"
                  value={editData?.ubicacion_data?.nombre}
                  size={gridSizeMdLg4}
                  disabled={true}
                />
                <Grid item {...gridSizeMdLg12}>
                  <Controller
                    name="observaciones.observacionSolicitante"
                    control={form.control}
                    rules={{ required: "Campo requerido" }} // validación si quieres
                    render={({ field }) => (
                      <TextField
                        {...field}
                        variant="outlined"
                        label="Observación"
                        multiline
                        rows={2}
                        fullWidth
                        required
                        error={!!errors.observaciones?.observacionSolicitante}
                        helperText={errors.observaciones?.observacionSolicitante?.message}
                        inputProps={{ style: { textTransform: 'uppercase' } }}
                        onChange={field.onChange}
                      /*    onChange={(e) => {
                           field.onChange(e.target.value.toUpperCase()); // aquí se transforma correctamente
                         }} */
                      />
                    )}
                  />
                </Grid>
              </Grid>

            </Paper>

          </Grid>




          {/* <Grid item {...gridSizeMdLg12}>
            <Controller
              name="observaciones.observacionSolicitante"
              control={form.control}
              rules={{required: "campo requerido"}}
              render={({ field }) => (
                <TextField
                {...field}
                  /* {...form.register("observaciones.observacionSolicitante")} */
                  /* required={true}
                  variant="outlined"
                  label="Observación"
                  multiline
                  rows={2}
                  fullWidth
                  error={!!errors.observaciones?.observacionSolicitante}
                  helperText={errors.observaciones?.observacionSolicitante?.message}
                  onChange={(e) => {
                    field.onChange(e.target.value.toUpperCase());
                  }}
                />

              )}
            />

          </Grid> */}
          <Grid item {...gridSize}>
            <Paper className="paper-producto">
              <Grid container spacing={1} justifyContent={"space-between"} alignItems={'center'}>
                <Grid item>
                  <TabTextLabel text={'Items Seleccionado'} mt={0} pb={0} pl={0} pt={0} />
                </Grid>
                <Grid item>
                  <ModalProductoComponente
                    ubicacion={form.watch('ubicacion')}
                    onChange={(e) => {
                      const aux: MaterialTransferido = {
                        id: e.id_producto,
                        codigo: e.codigo,
                        cantidad: '1',
                        contiene_serie: e.contiene_serie,
                        producto_data: {
                          codigo: e.codigo,
                          categoria_producto: e.categoria_producto,
                          subcategoria_producto: e.subcategoria_producto,
                          descripcion: e.descripcion,
                          stock_actual: e.stockActual,
                          modelo_producto: e.modelo_producto,
                          marca_producto: e.marca_producto,
                          unidad_medida: e.unidad_medida,
                          presentacion: e.presentacion,
                        },
                        series: [],
                      }
                      handleAgregarProducto(aux)
                    }}
                  />

                </Grid>
                <div className="linea"></div>
                <Grid item xs={12}>
                  <SampleTablePagination
                    columns={columnsSolicitudIngreso}
                    data={paginatedData}
                    rowCount={productos.length}
                    setPagination={setPagination}
                    pagination={pagination}
                    rowNumber={true}
                  />
                </Grid>
              </Grid>

            </Paper>

          </Grid>
        </Grid>

      </SingleTableBoxScene>
    </>
  )
}